// tslint:disable: max-line-length
// tslint:disable: no-console
import React from "react";
import { FlowBox } from "../../core/atoms/atoms";
import { isDev } from "../../core/detection";
import { officeHours } from "../../web/views/customer/customerEnquiry/utils";
import { handleError } from "../errorHandler";
import "./errorBoundary.scss";

interface LocalState {
  showDetails?: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<{}, LocalState> {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: isDev,
    };
  }

  public static getDerivedStateFromError(error: Error) {
    return { error };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    handleError(error);
  }

  public render() {
    const { error, showDetails } = this.state;

    if (error) {
      return (
        <div className="error-boundary">
          <img src="/images/sad-sloth.png" width={300} height={288} />
          <h2>Something went wrong</h2>

          <p className="error-boundary-message error-boundary-message__public">There was an error when trying to show you this part of the site. If this keeps happening, please contact the TravelLocal team at <a href="mailto:team@travellocal.com"><i className="icon icon-envelop5" /> team@travellocal.com</a> or call us in the office at <a href="tel:+441173257898"><i className="icon icon-phone2" /> +44 (0)117 325 7898</a>. We're available {officeHours}.</p>

          <p className="error-boundary-message error-boundary-message__partners">There was an error when trying to show you this part of the site. If this keeps happening, please contact the TravelLocal team at <a href="mailto:partners@travellocal.com"><i className="icon icon-envelop5" /> partners@travellocal.com</a> or call us in the office at <a href="tel:+441173257898"><i className="icon icon-phone2" /> +44 (0)117 325 7898</a></p>

          {showDetails &&
            <div className="error-boundary-details">
              <h4>Error details</h4>
              {error && <pre>{error.message}</pre>}
              {isDev && (
                <React.Fragment>
                  {error && <pre>{error.stack}</pre>}
                  <p className="error-boundary-message error-boundary-message__details">See also the console and logs</p>
                </React.Fragment>
              )}
            </div>
          }

          <FlowBox className="error-boundary-actions">
            {!showDetails &&
              <a className="secondary-button heading--4 text--dark" onClick={() => this.setState({ showDetails: true })}>
                View error details
              </a>
            }
            <a className="secondary-button heading--4 text--dark" onClick={() => this.setState({ error: null })}>
              Try again
            </a>
            <a className="secondary-button heading--4 text--dark" onClick={() => window.location.reload(true)}>
              Reload the page
            </a>
          </FlowBox>
        </div>
      );
    }
    else {
      return this.props.children;
    }
  }
}
